module.exports = __webpack_public_path__ + "media/images/icons/youtube-26d32e092f29ad3c66440e31273480cb.svg";